import {
  TranslationMessages,
  TranslationMessagesInner
} from '../translationMessages';
import en from './en.json';

const messages: TranslationMessagesInner = en;

export default messages as TranslationMessages;
